let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kZMTi")).then(() => parcelRequire('6vucW'));